 /**
 * Created by Shiv Roy on 21/11/17.
 */
import { showFormatedDate, showFormattedTime, base64Encode, showFormatedDateandTime } from '../../../../actions/utilAction';
import classNames from 'classnames';
import { renderCheckBox, renderTextArea, renderTextField, renderTimePicker } from '../../../../components/reduxFields';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
// import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import moment from 'moment';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

import { getPatientSingleEncounters } from '../../actions/PatientActions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptid: props.match.params.apptid,
      encid: props.match.params.id,
      patientId: null,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      renderingProviderName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
    };
    this.handleBackClick = this.handleBackClick.bind(this);    
  }

  componentWillMount() {
    let searchObj = {
      'apptId': this.state.apptid,
      'encounterId': this.state.encid,
    };
    this.props.getPatientSingleEncounters(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
        });

        let renderingProviderNames = [];
        appointmentData.appointmentRenderingProviders.forEach((staff) => {
          renderingProviderNames.push(staff.renderingProviderName);
        });

        this.setState({
          patientId: appointmentData.patientID,
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          renderingProviderName: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {}, renderingProviderSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
            if (signObj.renderingProviderSign) {
              let data = {
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                Name: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              renderingProviderSignObj = data;
            }
          });
        }
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
          enderingProviderSign : renderingProviderSignObj,
        });
      }
    }

    
  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <tr key={index}>
              <td width="30%">{diagnosis.icdCode}</td>
              <td width="70%">{diagnosis.description ? diagnosis.description : ''}</td>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </tr>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <tr key={index}>
            <td width="20%">{cpt.serviceCode ? cpt.serviceCode : '-'}</td>
            <td width="30%">{cpt.attachedModifiers ? cpt.attachedModifiers : '-'}</td>
            <td width="50%">{cpt.description ? cpt.description : '-'}</td>
          </tr>
        );
      });
    }
  }

  handleBackClick = () => {
    let encPatientId = this.state.patientId ? base64Encode(`${this.state.patientId}`) : null;
    if (this.props.location.state && this.props.location.state.isRedirectFromPatientEncounter && encPatientId) {
      history.push(`/client/encounter/${encPatientId}`);
    } else {
      history.push('/dashboard');
    }
  };
    
  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    let totalUnitsConsumed = (this.props.singleEncounter && this.props.singleEncounter.unitsConsumed) || 0;

    return (
      <div>
        {/* <h2 className="page_title">Client Encounter</h2>
        <PatientInfo patientId={this.state.patientid} />
        <div className="clearfix"></div> */}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <CommonButton label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>
              
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                  <h3>Session Note</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
             
             
              <div className="row mt-35">               
                <div className="col-sm-12 panel_title">
                  <h6><strong>Session Attendees</strong></h6><span style={{ color: 'red'}}>*</span>                  
                  </div>                      
              </div>
              <div className="row">
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Attendees_BT"
                    label="BT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Attendees_Client"
                    label="Client"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Attendees_Supervisor"
                    label="Supervisor"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Attendees_Parent"
                    label="Parent(S)/Guardian"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="OtherAttendees"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherAttendees &&
                  (<div className='col-sm-3 require'>
                  <Field
                    name="OtherAttendeesNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>                          
              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Observed maladaptive behavior</strong></h6></div>            
              </div>        
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservedElopement"
                    label="Elopement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservedUnsafe"
                    label="Hyperactive/Impulsive/Unsafe behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservedRigid"
                    label="Rigid/Ritualistic behavior "
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservedAggression"
                    label="Self-injury/Aggression/Property destruction"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservedTantrums"
                    label="Tantrums/Opposition/Defiance"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservedVocal"
                    label="Vocal/Motor stereotypy"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservedOther"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorObservedOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherObservedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
                </div>

              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Behavior reduction strategies used</strong></h6></div>            
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehaviorAntecedent"
                    label="Antecedent/Consequence Interventions"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehavioralMomentum"
                    label="Behavioral Momentum"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehaviorDifferential"
                    label="Differential Reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehaviorResponse"
                    label="Response Interruption and Redirection "
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehaviorVisualSupports"
                    label="Token Economy/Visual Supports"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                           
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehaviorOther"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorBehaviorOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherBehaviorNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row mt-35">
                <div className='col-sm-12 require'>
                  <Field
                    name="SummaryOfBehaviorObservedAndOutcome"
                    type="text"
                    fullWidth={true}
                    label="Summary of behavior(s) observed and outcome of strategy"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}                    
                  />
                </div>
              </div>
      
              <div className="row mt-35">               
                <div className="col-sm-12 panel_title">
                  <h6><strong>Domains Addressed</strong></h6><span style={{ color: 'red'}}>*</span>                  
                  </div>                      
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DomainAdaptive"
                    label="Adaptive Living"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DomainCognitive"
                    label="Cognitive and Executive Functioning"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DomainLanguage"
                    label="Language and Communication"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DomainPlay"
                    label="Play/Leisure"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DomainSocial"
                    label="Social Emotional "
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                               
                </div>
              
              <div className="row mt-35">               
                <div className="col-sm-12 panel_title">
                  <h6><strong>Strategies Used</strong></h6><span style={{ color: 'red'}}>*</span>                  
                  </div>                      
              </div>   
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrategiesDiscrimination"
                    label="Discrimination Training/DTT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrategiesModeling"
                    label="Modeling/Role Play"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrategiesNaturalistic"
                    label="Naturalistic Intervention/Generalization"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrategiesPairing"
                    label="Pairing"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrategiesPrompting"
                    label="Prompting and Fading"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrategiesShaping"
                    label="Shaping/Task Analysis/Chaining"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                           
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrategiesOther"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorStrategiesOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherStrategiesNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row mt-35">               
                <div className="col-sm-12 panel_title">
                  <h6><strong>Target(s)</strong></h6><span style={{ color: 'red'}}>*</span>                  
                  </div>                      
              </div>   
              <div className="row">
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Target_Introduced"
                    label="Introduced"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Target_Mastered"
                    label="Mastered"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Target_Maintained"
                    label="Maintained"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
              </div>

              <div className="row mt-35">               
                <div className="col-sm-12 panel_title">
                  <h6><strong>Plan</strong></h6><span style={{ color: 'red'}}>*</span>                  
                  </div>                      
              </div>   
              <div className="row">
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Plan_IntroNewTarget"
                    label="Intro new targets/programs"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Plan_ContinueCurrentTarget"
                    label="Continue current targets/strategies"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Plan_ModificationsNeeded"
                    label="Modifications Needed"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>               
              </div>


              <div className="row mt-35">
                <div className='col-sm-12 require'>
                  <Field
                    name="SummaryOfProgressAndSuggestions"
                    type="text"
                    fullWidth={true}
                    label="Summary of progress and suggestions"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}                    
                  />
                </div>
              </div>

              <div className="row mt-35">               
                <div className="col-sm-12 panel_title">
                    <h6><strong>(Clinical Supervisor/BCBA/QBA only)</strong></h6>    
                </div>                      
                <div className="col-sm-12 panel_title">
                  <h5>Protocol modifications</h5>  
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Assessment"
                    label="Assessment/FBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BIPDevelopment"
                    label="BIP development/modifications"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Graphing"
                    label="Data analysis/Graphing"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ParentClinicalSupport"
                    label="Parent/Caregiver clinical support/review"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgramDevelopment"
                    label="Program development/modification"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherProtocol"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherProtocol &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

            
              <div className="row mt-35">
                <div className='col-sm-12 require'>
                  <Field
                    name="SummaryOfProgressAndSuggestions"
                    type="text"
                    fullWidth={true}
                    label="Summary of progress and suggestions"
                    // autoHeight={true}
                    rows={8}
                    disabled={true}
                    component={renderTextArea}                    
                  />
                </div>
              </div>

              <div className="row mt-35">               
                <div className="col-sm-12 panel_title">
                    <h6><strong>(Clinical Supervisor/BCBA/QBA only)</strong></h6>    
                </div>                      
                <div className="col-sm-12 panel_title">
                  <h5>Protocol modifications</h5>  
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Assessment"
                    label="Assessment/FBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BIPDevelopment"
                    label="BIP development/modifications"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Graphing"
                    label="Data analysis/Graphing"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ParentClinicalSupport"
                    label="Parent/Caregiver clinical support/review"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgramDevelopment"
                    label="Program development/modification"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Other"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>

            
            
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Service Code</TableHeaderColumn>
                      <TableHeaderColumn width="30%">Modifiers</TableHeaderColumn>
                      <TableHeaderColumn width="50%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                  {this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  //let initialData = {};
  let initialData = {
    challengingBXModel: [{}],
    skillAcquisitionModel: [{}]
  };  
  let appointmentTime = null;
  if (state.patient.singleEncounter && state.patient.singleEncounter) {
   
    if (state.patient.singleEncounter.sessionNotes_Hyperion) {      
      
      initialData['Attendees_BT'] = state.patient.singleEncounter.sessionNotes_Hyperion.attendees_BT;
      initialData['Attendees_Client'] = state.patient.singleEncounter.sessionNotes_Hyperion.attendees_Client;
      initialData['Attendees_Supervisor'] = state.patient.singleEncounter.sessionNotes_Hyperion.attendees_Supervisor;
      initialData['Attendees_Parent'] = state.patient.singleEncounter.sessionNotes_Hyperion.attendees_Parent;
      initialData['OtherAttendees'] = state.patient.singleEncounter.sessionNotes_Hyperion.other;
      initialData['OtherAttendeesNotes'] = state.patient.singleEncounter.sessionNotes_Hyperion.otherAttendeesNotes;

      initialData['Target_Introduced'] = state.patient.singleEncounter.sessionNotes_Hyperion.target_Introduced;
      initialData['Target_Mastered'] = state.patient.singleEncounter.sessionNotes_Hyperion.target_Mastered;
      initialData['Target_Maintained'] = state.patient.singleEncounter.sessionNotes_Hyperion.target_Maintained;

      initialData['Plan_IntroNewTarget'] = state.patient.singleEncounter.sessionNotes_Hyperion.plan_IntroNewTarget;
      initialData['Plan_ContinueCurrentTarget'] = state.patient.singleEncounter.sessionNotes_Hyperion.plan_ContinueCurrentTarget;
      initialData['Plan_ModificationsNeeded'] = state.patient.singleEncounter.sessionNotes_Hyperion.plan_ModificationsNeeded;
        
      initialData['SummaryOfBehaviorObservedAndOutcome'] = state.patient.singleEncounter.sessionNotes_Hyperion.summaryOfBehaviorObservedAndOutcome;
      initialData['SummaryOfProgressAndSuggestions'] = state.patient.singleEncounter.sessionNotes_Hyperion.summaryOfProgressAndSuggestions;

        // ObservedBehavior_Session_Hyperion
        initialData['ObservedElopement'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.observedElopement;
        initialData['ObservedUnsafe'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.observedUnsafe;
        initialData['ObservedRigid'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.observedRigid;
        initialData['ObservedAggression'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.observedAggression;
        initialData['ObservedTantrums'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.observedTantrums;
        initialData['ObservedVocal'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.observedVocal;
        initialData['ObservedOther'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.observedOther;
        initialData['OtherObservedNotes'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.otherObservedNotes;

        initialData['BehaviorAntecedent'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.behaviorAntecedent;
        initialData['BehavioralMomentum'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.behavioralMomentum;
        initialData['BehaviorDifferential'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.behaviorDifferential;
        initialData['BehaviorResponse'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.behaviorResponse;
        initialData['BehaviorVisualSupports'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.behaviorVisualSupports;        
        initialData['BehaviorOther'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.behaviorOther;
        initialData['OtherBehaviorNotes'] = state.patient.singleEncounter.sessionNotes_Hyperion.observedBehavior_Session_Hyperion.otherBehaviorNotes;

       
        // domainsAndStrategies_Session_Hyperion
        initialData['DomainAdaptive'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.domainAdaptive;
        initialData['DomainCognitive'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.domainCognitive;
        initialData['DomainLanguage'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.domainLanguage;
        initialData['DomainPlay'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.domainPlay;
        initialData['DomainSocial'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.domainSocial;

        initialData['StrategiesDiscrimination'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.strategiesDiscrimination;
        initialData['StrategiesModeling'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.strategiesModeling;
        initialData['StrategiesNaturalistic'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.strategiesNaturalistic;
        initialData['StrategiesPairing'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.strategiesPairing;

        initialData['StrategiesPrompting'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.strategiesPrompting;
        initialData['StrategiesShaping'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.strategiesShaping;
        initialData['StrategiesOther'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.strategiesOther;
        initialData['OtherStrategiesNotes'] = state.patient.singleEncounter.sessionNotes_Hyperion.domainsAndStrategies_Session_Hyperion.otherStrategiesNotes;
      

        // protocolModifications_Session_Hyperion
        initialData['Assessment'] = state.patient.singleEncounter.sessionNotes_Hyperion.protocolModifications_Session_Hyperion.assessment;
        initialData['BIPDevelopment'] = state.patient.singleEncounter.sessionNotes_Hyperion.protocolModifications_Session_Hyperion.bipDevelopment;
        initialData['Graphing'] = state.patient.singleEncounter.sessionNotes_Hyperion.protocolModifications_Session_Hyperion.graphing;
        initialData['ParentClinicalSupport'] = state.patient.singleEncounter.sessionNotes_Hyperion.protocolModifications_Session_Hyperion.parentClinicalSupport;
        initialData['ProgramDevelopment'] = state.patient.singleEncounter.sessionNotes_Hyperion.protocolModifications_Session_Hyperion.programDevelopment;
        initialData['OtherProtocol'] = state.patient.singleEncounter.sessionNotes_Hyperion.protocolModifications_Session_Hyperion.other;
        initialData['OtherNotes'] = state.patient.singleEncounter.sessionNotes_Hyperion.protocolModifications_Session_Hyperion.otherNotes;
    }

    if (state.patient.singleEncounter.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = state.patient.singleEncounter.patientEncounterDiagnosisCodes;
    }
    if (state.patient.singleEncounter.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = state.patient.singleEncounter.patientEncounterServiceCodes;
    }

    // if(state.patient.singleEncounter.appointmentStartDateTime){
    //   let startTimehours = state.patient.singleEncounter.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = state.patient.singleEncounter.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ?
    //     (parseInt(startTimehours, 10) - 12 < 10 ?
    //       `0${parseInt(startTimehours, 10) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('state.patient.singleEncounter.............', state.patient.singleEncounter);

    if (state.patient.singleEncounter.startDateTime) {
      let startTimehours = state.patient.singleEncounter.startDateTime.substr(11, 2);
      let endTimehours = state.patient.singleEncounter.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = state.patient.singleEncounter.locationName;
    initialData['staffName'] = state.patient.singleEncounter.staffName;
    initialData['appointmentDate'] = state.patient.singleEncounter.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = state.patient.singleEncounter.PatientLocationName;
    initialData['serviceEndTime'] = moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('HH:mm:ss');

  }

  return {
    selectorOtherAttendees: selector(state, 'OtherAttendees'),
    selectorObservedOther: selector(state, 'ObservedOther'),
    selectorBehaviorOther: selector(state, 'BehaviorOther'),
    selectorStrategiesOther: selector(state, 'StrategiesOther'),
    selectorOtherProtocol: selector(state, 'OtherProtocol'),

    singleEncounter: state.patient.singleEncounter,
    initialValues: initialData,  
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounters })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/SessionNotes_Hyperion.js